import React, { useState } from 'react';
import { Formik, Form } from 'formik';

import { SR_API_ACTION_NEW_TENANT_ALERT_APPLICATION } from 'api/actionTypes';

import { createFormValidationFn, createInitialValues } from 'client/helpers/formikHelpers';
import postWithState from 'client/actions/postWithState';

import ButtonDeprecated, { BUTTON_THEME_YELLOW } from 'client/components/ButtonDeprecated';
import SrDarkModal from 'client/components/SrDarkModal';
import SrFormikField from 'client/components/SrFormikField';
import SrModalContent from 'client/components/SrModalContent';

function getFormFields() {
  return [
    {
      id: 'tenantAlertApplicationId',
      type: 'number',
      title: 'Application ID',
      properties: {
        placeholder: 'XXXXXX',
      },
      validations: ['required'],
    },
  ];
}

const SrTenantAlertReportFormModal = ({ userId, onClose, reloadDataTable, dispatch }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formFields = getFormFields();

  const onSubmit = (values) => {
    setIsSubmitting(true);

    dispatch(postWithState, {
      action: SR_API_ACTION_NEW_TENANT_ALERT_APPLICATION,
      payload: {
        userId,
        tenantAlertApplicationId: `${values.tenantAlertApplicationId}`,
      },
      onSuccess: async () => {
        reloadDataTable().then(() => {
          onClose();
          setIsSubmitting(false);
        });
      },
      onError: (error) => {
        onClose();
        setIsSubmitting(false);
        global.alert(error.message);
      },
    });
  };

  return (
    <SrDarkModal onClose={onClose}>
      <SrModalContent>
        <div>
          <Formik
            enableReinitialize
            initialValues={createInitialValues({
              formFields: formFields,
            })}
            validateOnChange={false}
            validate={createFormValidationFn(formFields)}
            onSubmit={onSubmit}
            render={(formikBag) => {
              return (
                <Form>
                  {formFields.map((formField) => (
                    <SrFormikField key={formField.id} formField={formField} formikBag={formikBag} />
                  ))}
                  <ButtonDeprecated
                    type="submit"
                    theme={BUTTON_THEME_YELLOW}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                  </ButtonDeprecated>
                </Form>
              );
            }}
          />
        </div>
      </SrModalContent>
    </SrDarkModal>
  );
};

SrTenantAlertReportFormModal.displayName = 'SrTenantAlertReportFormModal';

export default SrTenantAlertReportFormModal;
